import { loginSuccess, loginfailure, logout } from "./reducer";
import toast from "react-hot-toast";
import AuthServices from "../../../services/AuthServices/AuthServices";
// import { useModal } from "src/Context/ModalContext";

// export const login =
//   (credentials, history, handleVerifyClick) => async (dispatch, getState) => {
//     try {
//       const response = await AuthServices.login(credentials);
//       const user = response;
//       console.log("USER", user);
//       const customerId = user?.user?.id;
//       const isActivated = user?.user?.is_activated; // Assuming `isActivated` is part of the user object
//       console.log("isActivated", isActivated);
//       if (user) {
//         // If the user is not activated, open the verify modal
//         if (!isActivated) {
//           localStorage.setItem("user", JSON.stringify(user));
//           handleVerifyClick(); // Open verification modal
//           return;
//         }

//         // Retrieve the booking data from local storage
//         const bookingData =
//           JSON.parse(localStorage.getItem("bookingData")) || {};
//         const { selectedSlots = [] } = bookingData;

//         if (selectedSlots.length > 0) {
//           // If there are selected slots, navigate to the payment page
//           history(`/payment/${user.user.id}`);
//         } else {
//           // Otherwise, navigate to the booking page
//           history("/booking");
//         }

//         dispatch(loginSuccess(user));
//         toast.success("Welcome to Cosmos Driving!");
//       } else {
//         dispatch(loginfailure());
//         toast.error("Invalid username or password1. Please try again.");
//       }
//     } catch (error) {
//       dispatch(loginfailure());
//       toast.error("Invalid username or password2. Please try again.");
//     }
//   };

export const login = (credentials, history, handleVerifyClick, onClose) => async (dispatch) => {
  try {
    console.log("credentials", credentials);
    const response = await AuthServices.login(credentials);
    
    console.log("responselogin", response);
    const user = response;
    const isActivated = user?.user?.is_activated;

    // Store the user in localStorage regardless of activation status
    localStorage.setItem("user", JSON.stringify(user));

    if (user) {
      if (!isActivated) {
        handleVerifyClick(); // Open verification modal from component
        return;
      }

      const bookingData = JSON.parse(localStorage.getItem("bookingData")) || {};
      const { totalSelectedSlots = [] } = bookingData;

      if (totalSelectedSlots.length > 0) {
        onClose();
        history(`/payment`);
      } else {
        onClose();
        history("/booking");
      }

      dispatch(loginSuccess(user));
      toast.success("Welcome to Cosmos Driving!");
    } else {
      dispatch(loginfailure());
      toast.error("Invalid username or password. Please try again.");
    }
  } catch (error) {
    console.log("Login error response", error.response);

    if (error.response && error.response.status === 403) {
      const user = error.response.data; // Extract user data from the error response, if available

      // Store the error response (user data) in localStorage
      localStorage.setItem("user", JSON.stringify(user));

      // Handle the 403 Forbidden error when the user's email is not activated
      toast.error("Your email is not activated. Please check your inbox to verify your account.");
      handleVerifyClick(); // Open the verification modal
      return;
    }

    dispatch(loginfailure());
    toast.error(`Login error: ${error.response.data.error || "An unexpected error occurred."}`);
    // console.error("Login Error: ", error);
  }
};



export const logoutUser = () => (dispatch) => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("selectedSlots");
  localStorage.removeItem("bookingData");

  dispatch(logout());
};
